import { inject } from '@/generic/authentication/injections.ts';
import { AUTHENTICATION } from '@/generic/authentication/AuthenticationKeys.ts';
import { AuthenticatedFetcher } from '@/generic/authentication/primary/AuthenticatedFetcher.ts';
import type { FetchOptions } from 'ofetch';

export {
  AUTHENTICATION_OPENID,
  AUTHENTICATION_FAKE_API,
  provideAuthentication,
  type AuthenticationAdapter,
} from './AuthenticationProvider.ts';

export type { AuthenticatedFetcher } from '@/generic/authentication/primary/AuthenticatedFetcher.ts';

export { SigninCallback } from '@/generic/authentication/primary/SigninCallback.tsx';

export const login = async (): Promise<void> => await inject(AUTHENTICATION).login();
export const logout = async (): Promise<void> => await inject(AUTHENTICATION).logout();

export const buildFetcher = (options?: FetchOptions) =>
  new AuthenticatedFetcher({ options, authentication: inject(AUTHENTICATION) });
